(function() {
  'use strict';

  class VariantImageSwitcher {
    constructor() {
      this.productJson = null;
      this.currentVariantId = null;
      this.init();
    }

    init() {
      this.loadProductData();
      this.setupEventListeners();
    }

    loadProductData() {
      const productJsonElement = document.querySelector('[data-product-json]');
      if (productJsonElement) {
        try {
          this.productJson = JSON.parse(productJsonElement.textContent);
        } catch (e) {
          console.error('Failed to parse product JSON:', e);
        }
      }
    }

    setupEventListeners() {
      document.addEventListener('variant:change', (event) => {
        if (event.detail && event.detail.variant) {
          this.handleVariantChange(event.detail.variant);
        }
      });

      const variantSelects = document.querySelectorAll('select[name="id"]');
      variantSelects.forEach(select => {
        select.addEventListener('change', (e) => {
          const variantId = parseInt(e.target.value);
          this.updateImageByVariantId(variantId);
        });
      });

      const variantInputs = document.querySelectorAll('input[name="id"]');
      variantInputs.forEach(input => {
        input.addEventListener('change', (e) => {
          const variantId = parseInt(e.target.value);
          this.updateImageByVariantId(variantId);
        });
      });

      const optionSelects = document.querySelectorAll('[data-option-select]');
      optionSelects.forEach(select => {
        select.addEventListener('change', () => {
          setTimeout(() => this.checkCurrentVariant(), 100);
        });
      });
    }

    handleVariantChange(variant) {
      if (variant.id !== this.currentVariantId) {
        this.currentVariantId = variant.id;
        this.updateMainImage(variant);
      }
    }

    updateImageByVariantId(variantId) {
      if (!this.productJson || !this.productJson.variants) return;

      const variant = this.productJson.variants.find(v => v.id === variantId);
      if (variant) {
        this.handleVariantChange(variant);
      }
    }

    checkCurrentVariant() {
      const variantIdInput = document.querySelector('input[name="id"]:checked') ||
                            document.querySelector('select[name="id"]');

      if (variantIdInput) {
        const variantId = parseInt(variantIdInput.value);
        this.updateImageByVariantId(variantId);
      }
    }

    updateMainImage(variant) {
      if (!variant.featured_image) return;

      const mainImage = document.querySelector('.product__media img[data-media-id]');
      const featuredMediaId = variant.featured_image.id;

      if (mainImage && variant.featured_image.src) {
        mainImage.src = variant.featured_image.src;
        mainImage.srcset = this.generateSrcset(variant.featured_image.src);
        mainImage.alt = variant.featured_image.alt || variant.name;
      }

      if (featuredMediaId) {
        const targetMedia = document.querySelector(`[data-media-id="${featuredMediaId}"]`);
        if (targetMedia) {
          const allMedia = document.querySelectorAll('.product__media');
          allMedia.forEach(media => {
            media.classList.remove('is-active');
            media.style.display = 'none';
          });
          targetMedia.classList.add('is-active');
          targetMedia.style.display = '';
          targetMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      const thumbnails = document.querySelectorAll('.product__media-thumbnail');
      thumbnails.forEach(thumb => {
        thumb.classList.remove('is-active');
        thumb.style.opacity = '0.6';
        if (thumb.dataset.mediaId == featuredMediaId) {
          thumb.classList.add('is-active');
          thumb.style.opacity = '1';
        }
      });
    }

    generateSrcset(src) {
      const baseUrl = src.split('?')[0];
      const widths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];
      return widths.map(width => `${baseUrl}?width=${width} ${width}w`).join(', ');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new VariantImageSwitcher());
  } else {
    new VariantImageSwitcher();
  }
})();
